import { Tab, Tabs } from "@material-ui/core";
import { useEffect, useState } from "react";
import clsx from "clsx";
import _ from "lodash";
import { useArchiveContext } from "../../context/archive.context";
import {decodeHtml} from "../../utils/helpers";

export const TagBubble = ({ data }) => {
	const { selectQueryParams } = useArchiveContext();

	const [tags, setTags] = useState([]);

	function handleClick(id) {
		const clickOnAllTag = _.find(tags, (tag) => tag.id == id).hasOwnProperty(
			"isTagAll"
		);

		if (clickOnAllTag) {
			setTags((s) =>
				s.map((tag) => {
					if (tag.hasOwnProperty("isTagAll")) tag.active = true;
					else tag.active = false;
					return tag;
				})
			);

			selectQueryParams({ tags: [] });

			return;
		}
		//
		setTags((s) => {
			const changedTags = _.map(s, (tag) => {
				if (tag.id == id) tag.active = !tag.active;

				return tag;
			});

			let selectedTags =
				_.filter(changedTags, (tag) => tag.active == true) || [];

			const tagAllIsSelected = _.find(selectedTags, (tag) =>
				tag.hasOwnProperty("isTagAll")
			);

			if (!selectedTags.length) {
				data[0].active = true;
				selectQueryParams({ tags: [] });

				return data;
			}

			if (selectedTags.length >= 2 && tagAllIsSelected) {
				changedTags[0].active = false;
				selectedTags = _.filter(selectedTags, (item) => !!item.queryParam);
			}

			const selectedQueryParams = _.map(selectedTags, (tag) => tag.queryParam);

			selectQueryParams({ tags: selectedQueryParams });

			return changedTags;
		});
	}

	useEffect(() => {
		data && data.length && setTags(data);
	}, [data]);

	return (
		<div className="tabsRoot tagsCnt">
			<Tabs
				value={"value"}
				variant="scrollable"
				scrollButtons="auto"
				aria-label="scrollable auto tabs example"
			>
				{_.map(tags, (item) => (
					<Tab
						onClick={(e) => {
							handleClick(item.id);
						}}
						label={decodeHtml(  item.name)}
						value={item.id}
						className={clsx({ "tag-53": true, active: item.active })}
					/>
				))}
			</Tabs>
		</div>
	);
};
